import { EventEmitter } from 'events';

export const eventEmitter = new EventEmitter();
export const emitter = eventEmitter;
